import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { ease } from '../lib/motion'

// Scroll reveal: y:24→0, opacity, once. Reduced-motion handled globally by framer.
export function Reveal({ children, delay = 0, y = 24, className }: { children: ReactNode; delay?: number; y?: number; className?: string }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '0px 0px -40px 0px' }}
      transition={{ duration: 0.5, ease: ease.out as unknown as number[], delay }}
    >
      {children}
    </motion.div>
  )
}
